export default "__VITE_ASSET__DRhIhOcZ__"